export var PortkeyVersion;
(function (PortkeyVersion) {
    PortkeyVersion["v1"] = "v1";
    PortkeyVersion["v2"] = "v2";
})(PortkeyVersion || (PortkeyVersion = {}));
export var PortkeyNameVersion;
(function (PortkeyNameVersion) {
    PortkeyNameVersion["v1"] = "portkey";
    PortkeyNameVersion["v2"] = "Portkey";
})(PortkeyNameVersion || (PortkeyNameVersion = {}));
